module.exports = {"410173108":"张庄镇","410173113":"八岗镇","410173116":"三官庙镇","410173202":"八千乡","410173203":"龙王乡","410173400":"新港街道","410173401":"郑港街道","410173404":"银河街道","410173405":"明港街道","410173580":"滨河街道","410173581":"冯堂街道","410173582":"清河街道","410173583":"龙港街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410173.json
// module id = 1641
// module chunks = 0